import { Box, Card, CardActions, CardContent, CardMedia, Grid, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { memo, useContext, useEffect, useState } from 'react'
import { AuthenticationContext } from '../../context/AuthenticationContext'
import { WmcContext } from '../../context/WmcContext'
import { WEB_KEY } from '../../api/AxiosApi'
import Image from 'mui-image'
import { BaseUrl } from '../../api/AxiosApi'
import { AppThemeContext } from '../../context/AppThemeContext'
import { logApi, MainSumApi } from '../../api/Api'
import { getDateTimeForDashboardTab1 } from '../../utils'
import { GiFruitTree } from "react-icons/gi";
import { MdCo2 } from "react-icons/md";
import { MdOutlineCo2 } from "react-icons/md";
import { GiCoalWagon } from "react-icons/gi";
import { GiReceiveMoney } from "react-icons/gi";

function TopHeader() {
    const [logData, setLogData] = useState([]);
    const { PrimaryColor } = useContext(AppThemeContext);
    const { LoggedInUserInfo } = useContext(AuthenticationContext)
    const { BrandLogo } = useContext(WmcContext)
    const { breakpoints, spacing } = useTheme()
    const LOGIN_ID = localStorage.getItem('LoginID')
    //const LOC_CODE = localStorage.getItem('LCODE')
    const matches = useMediaQuery(breakpoints.down('xl'));
    // console.log('DATAUSER', LoggedInUserInfo)
    const LOC_CODE = LoggedInUserInfo?.Loc_Code
    const PASS_KEY = "xxxxxx"

    const [mainData, setMainData] = useState([]);
    const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay)
    const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today)


    // const ImageUrl = "https://log.solaramr.com/api/CMN_02/GET_COM_LOGO?LOGIN_ID=2402104&LOC_CODE=200ET&PASS_KEY=xxxxxx&WEB_KEY=WEBXYZ321"



    // const ImageUrl = `https://log.solaramr.com/api/CMN_02/GET_COM_LOGO?LOGIN_ID=${LOGIN_ID}&LOC_CODE=${LOC_CODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`
    const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${LOGIN_ID}&LOC_CODE=${LOC_CODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`





    const [credentials, setCredentials] = useState({
        LOGIN_ID: localStorage.getItem("LoginID"),
        LOC_CODE: localStorage.getItem("LCODE"),
        PASS_KEY: localStorage.getItem("PASS_KEY") || "xyz",
        WEB_KEY: localStorage.getItem("WEB_KEY") || "WEBXYZ321",
    });


    // this is fetching for MIDDLE data
    const fetchLogData = async () => {
        const res = await logApi(credentials);
        if (res?.TOT_LIVE_KW_NEW && Array.isArray(res.TOT_LIVE_KW_NEW)) {
            setLogData(res.TOT_LIVE_KW_NEW);
        } else {
            setLogData([]);
        }
    };

    useEffect(() => {
        fetchLogData();
    }, [credentials.LOGIN_ID]);

    // This fetching for total inverters


    const [sumCredentials, setSumCredentials] = useState({
        LOGIN_ID: localStorage.getItem("LoginID") || "",
        PASS_KEY: localStorage.getItem("KEY") || "xyz",
        LCODE: localStorage.getItem("LCODE") || "",
        DT1: StartDate,
        DT2: EndDate,
        TYP: "A",
        WEB_KEY: "WEBXYZ321",
        FID: "216HT001",
    });

    // this is fetching for MAIN_SUM
    const fetchData = async () => {
        const res = await MainSumApi(sumCredentials);
        if (res?.KWH_MIS_MAIN_SUM && Array.isArray(res.KWH_MIS_MAIN_SUM)) {
            setMainData(res.KWH_MIS_MAIN_SUM);
        } else {
            setMainData([]);
        }
    };


    useEffect(() => {
        fetchData();
    }, [sumCredentials]);


    return (
        <Stack rowGap={spacing(1)}>
            <Card elevation={0} sx={{ bgcolor: 'white' }}>
                <CardActions sx={{ justifyContent: "center", width: "100%" }}>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            justifyContent: "center",
                            alignItems: "center",
                            textAlign: "center",
                            width: "100%",
                            gap: 2,

                        }}
                    >
                        {mainData.map((item, index) => (
                            <Typography key={index} variant="body1">

                                {/* <span style={{ fontSize: "1.3rem", color: PrimaryColor }}><GiReceiveMoney /></span> Revenue Gains ({LoggedInUserInfo?.CURRENCY}) &nbsp;
                                <span style={{ color: PrimaryColor, fontSize: "14px", fontWeight: "bold" }}>
                                    {item.TOT_Rev !== undefined ? item.TOT_Rev : "N/A"}
                                </span> */}
                                {LoggedInUserInfo?.TAB_REVENUE === "1" && (
                                    <>
                                        <span style={{ fontSize: "1.3rem", color: PrimaryColor }}>
                                            <GiReceiveMoney />
                                        </span>

                                        {" "}Revenue Gains ({LoggedInUserInfo?.CURRENCY}) &nbsp;

                                        <span style={{ color: PrimaryColor, fontSize: "14px", fontWeight: "bold" }}>
                                            {item.TOT_Rev ?? "N/A"}
                                        </span>
                                    </>
                                )}

                                &nbsp;&nbsp;&nbsp;
                                <span style={{ fontSize: "1.4rem", color: PrimaryColor }}><MdOutlineCo2 /></span> Reduction &nbsp;
                                <span style={{ color: PrimaryColor, fontSize: "14px", fontWeight: "bold" }}>
                                    {item.co2_ton !== undefined ? item.co2_ton : "N/A"}
                                </span>

                                &nbsp;&nbsp;&nbsp;
                                <span style={{ fontSize: "1.3rem", color: PrimaryColor }}><GiCoalWagon /></span> Coal Saved &nbsp;
                                <span style={{ color: PrimaryColor, fontSize: "14px", fontWeight: "bold" }}>
                                    {item.TOT_coal !== undefined ? item.TOT_coal : "N/A"}
                                </span>

                                &nbsp;&nbsp;&nbsp;
                                <span style={{ fontSize: "1.3rem", color: PrimaryColor }}><GiFruitTree /></span> Equivalent Tree Planted &nbsp;
                                <span style={{ color: PrimaryColor, fontSize: "14px", fontWeight: "bold" }}>
                                    {item.TOT_tree !== undefined ? item.TOT_tree : "N/A"}
                                </span>
                            </Typography>
                        ))}

                        {logData.map((item, index) => (
                            <Typography key={index} variant="body1">
                                {item?.INV_NO > 0 && (
                                    <>
                                        Total Inverter/s&nbsp;
                                        <span style={{ fontSize: "14px", fontWeight: "bold", color: "red" }}>{item.INV_NO}</span>&nbsp;&nbsp;&nbsp;
                                    </>
                                )}
                                {item?.SOLAR_MTR_NO > 0 && (
                                    <>
                                        Total Solar Meter/s&nbsp;
                                        <span style={{ fontSize: "14px", fontWeight: "bold", color: "red" }}>{item.SOLAR_MTR_NO}</span>&nbsp;&nbsp;&nbsp;
                                    </>
                                )}
                                {item?.LT_MAINS_NO > 0 && (
                                    <>
                                        Total LT MAINS&nbsp;
                                        <span style={{ fontSize: "14px", fontWeight: "bold", color: "red" }}>{item.LT_MAINS_NO}</span>&nbsp;&nbsp;&nbsp;
                                    </>
                                )}
                                {item?.DG_NO > 0 && (
                                    <>
                                        Total DG/s&nbsp;
                                        <span style={{ fontSize: "14px", fontWeight: "bold", color: "red" }}>{item.DG_NO}</span>&nbsp;&nbsp;&nbsp;
                                    </>
                                )}
                                {item?.NET_METER_NO > 0 && (
                                    <>
                                        Total Net Meter/s&nbsp;
                                        <span style={{ fontSize: "14px", fontWeight: "bold", color: "red" }}>{item.NET_METER_NO}</span>&nbsp;&nbsp;&nbsp;
                                    </>
                                )}
                                {item?.CHECK_METER > 0 && (
                                    <>
                                        Total Check Meter/s&nbsp;
                                        <span style={{ fontSize: "14px", fontWeight: "bold", color: "red" }}>{item.CHECK_METER}</span>&nbsp;&nbsp;&nbsp;
                                    </>
                                )}
                            </Typography>
                        ))}
                    </Box>
                </CardActions>
            </Card>


            <Grid container spacing={spacing(1)}>
                <Grid item xs={12} sm={12} md={4}>
                    <Card sx={{ height: matches ? 50 : 70, p: spacing(1), display: 'flex', alignItems: "center" }}>
                        <Stack>
                            <Typography textAlign={'start'} variant='body1'>{LoggedInUserInfo?.username}&nbsp; &nbsp;<span>(User_Id:{LOGIN_ID})</span></Typography>
                            <Typography textAlign={'start'} variant='body1'>Plant AC Capacity : {LoggedInUserInfo?.PLANT_CAPACITY} {LoggedInUserInfo?.AC_Unit} &nbsp; &nbsp; Plant DC Capacity : {LoggedInUserInfo?.DC_CAPACITY} {LoggedInUserInfo?.DC_Unit}</Typography>
                            <Typography textAlign={'start'} variant='body1'> {LoggedInUserInfo?.Address} &nbsp;, &nbsp;<span>({LoggedInUserInfo?.city})</span></Typography>
                        </Stack>
                                    </Card>
                </Grid>
                <Grid item xs={12} sm={12} md={4}>
                    <Card sx={{ height: matches ? 50 : 70, p: spacing(1), display: 'flex', alignItems: "center" }}>
                        <Stack>
                            <Typography variant='body1'>{LoggedInUserInfo?.MSG}</Typography>
                            <Typography variant='body1' sx={{ color: PrimaryColor }}>Plant Commissioned Date:{LoggedInUserInfo?.PLANT_COMMISSIONED_DATE}</Typography>
                            <Typography variant='body1' sx={{ color: PrimaryColor }}>Subscription Expiry Date:{LoggedInUserInfo?.subscription_expiry_date}</Typography>
                        </Stack>
                    </Card>
                </Grid>

                <Grid item xs={12} sm={12} md={4} display={'flex'} justifyContent={'center'}>
                    <Image fit='fill'
                        wrapperStyle={{
                            height: matches ? 50 : 70, borderRadius: "11px",
                            overflow: "hidden"
                        }}
                        src={ImageUrl ? ImageUrl : require('../../assets/img/basic/battery.png')}
                    />
                </Grid>
                
            </Grid>
        </Stack >
    )
}

export default memo(TopHeader)